"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialiseObserver = exports.Edge = void 0;
var Edge;
(function (Edge) {
    Edge["top"] = "top";
    Edge["bottom"] = "bottom";
})(Edge || (exports.Edge = Edge = {}));
/**
 *
 * @param targetItemRefs a store of the refs and seen statuses for each item
 * @param onIntersection the function to run when an observed item is intersected
 * @param observeAnItem function to start observing an item
 * @param onIntersectionCallback function to call when observed item is intersected
 * @returns an observer which will fire the provided event on intersecting each item
 */
const initialiseObserver = (targetItemRefs, onIntersection, observeAnItem) => {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            // Will fire on load for each entry regardless of the specified threshold below,
            // so don't include any entries that aren't actually on the screen
            if (entry.intersectionRatio > 0) {
                onIntersection(observer, entry, targetItemRefs);
            }
        });
    }, { threshold: [1] });
    Object.entries(targetItemRefs).forEach(([key, value]) => {
        observeAnItem(observer, value);
    });
    return observer;
};
exports.initialiseObserver = initialiseObserver;
//# sourceMappingURL=IntersectionObserver.js.map